import * as types from '../../../lib/actionTypes.es6';

export const initialState = {
  errors: null,
  loader: false,
  payments: [],
  page: 1,
  size: 20,
  total: 0,
  totalPages: 0,
  success_message: ''
};

export default function recentPaymentsReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_RECENT_PAYMENTS_REQUEST:
      return { 
        ...state, 
        loader: true, 
        errors: null
      };
      
    case types.GET_RECENT_PAYMENTS_SUCCESS:
      const { data, page, size, total } = action.payload;
      return { 
        ...state, 
        loader: false, 
        errors: null, 
        payments: data || [],
        page: page || 1,
        size: size || 20,
        total: total || 0,
        totalPages: Math.ceil((total || 0) / (size || 20))
      };
      
    case types.GET_RECENT_PAYMENTS_FAILURE:
      return { 
        ...state, 
        loader: false, 
        errors: action.payload,
        payments: [],
        total: 0,
        totalPages: 0
      };

    default:
      return state;
  }
}